import { Navigate } from "react-router-dom";

export default function HomeRoute() {
    const token = localStorage.getItem("token");

    if (token) {
        // Logged in → go to Main page
        return <Navigate to="/main" replace />;
    }

    // Not logged in → go to Login page
    return <Navigate to="/login" replace />;
}
